export default __webpack_public_path__ + "static/media/streetlights-logo.26154724.png";